import styles from "./HeaderEndo.module.scss";
import endoPicture from '../../../shared/assets/photo/endo/endo_1x.png';
import endoPicture_2x from '../../../shared/assets/photo/endo/endo_2x.png';
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import endoPictureMob from '../../../shared/assets/photo/endo/endoMob.png';
import endoPictureMob_2x from '../../../shared/assets/photo/endo/endoMob_2x.png';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP);

const HeaderEndo = () => {

    useGSAP(() => {
        gsap.fromTo(".endo__header", {opacity: 0,  y:10,}, 
                                    { opacity: 1,
                                    y:0,  
                                    duration: 1, 
                                    });
    }, [])

    return ( 
        <div>
            <div className={styles.content}>
                <img className={styles.picture} src={endoPicture}
                    srcSet={`${endoPicture_2x} 2x`} alt="эндодонтия" />

            <img className={styles.pictureMob} src={endoPictureMob}
                    srcSet={`${endoPictureMob_2x} 2x`} alt="эндодонтия" />
            <Stack              
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.header}>
                    <Text
                        type='h1' 
                        size ='xxl'
                        className={`endo__header ${styles.title}`}>
                            Эндодонтия
                    </Text>
            </Stack>
            </div>
        </div>
    );
}
 
export default HeaderEndo;